export default __webpack_public_path__ + "static/media/wipay-logo.f912bc9c.png";